import * as React from 'react'

import { cn } from '@/lib/utils'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'

const DEFAULT_CONTENT_CLASS =
  'tw:w-80 tw:max-h-[min(640px,var(--available-height,85vh))]'

export interface IOptionsPopoverShellProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
  // Trigger-driven surfaces render their own button; an anchored one is
  // externally controlled and positions against a host element's ref.
  trigger?: React.ReactNode
  anchor?: HTMLElement
  // A body portal renders outside a fullscreen subtree, hence invisible.
  portalContainer?: React.ComponentProps<
    typeof PopoverContent
  >['portalContainer']
  // An anchored surface has no trigger to name it.
  'aria-label'?: string
  backdrop?: boolean
  side?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
  contentClassName?: string
}

const OptionsPopoverShell: React.FC<IOptionsPopoverShellProps> = ({
  open,
  onOpenChange,
  trigger,
  anchor,
  portalContainer,
  'aria-label': ariaLabel,
  backdrop,
  children,
  side = 'bottom',
  align = 'start',
  sideOffset = 4,
  contentClassName,
}) => {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      {!!trigger && <PopoverTrigger render={trigger as React.ReactElement} />}
      <PopoverContent
        anchor={anchor}
        portalContainer={portalContainer}
        aria-label={ariaLabel}
        backdrop={backdrop}
        side={side}
        align={align}
        sideOffset={sideOffset}
        className={cn(DEFAULT_CONTENT_CLASS, contentClassName)}
      >
        {children}
      </PopoverContent>
    </Popover>
  )
}

export default OptionsPopoverShell
